import type { DietReward } from "@couples/shared";

import { supabase } from "../supabase";

interface RewardRow {
  couple_id: string;
  title: string;
  target_loss: number | string;
  achieved_at: string | null;
}

const COLUMNS = "couple_id, title, target_loss, achieved_at";

/** ふたりのごほうびは couple に1つ。まだ決めていなければ null */
export async function fetchReward(): Promise<DietReward | null> {
  const { data, error } = await supabase.from("diet_rewards").select(COLUMNS).maybeSingle();
  if (error) throw error;
  if (data === null) return null;
  const row: RewardRow = data;
  return {
    coupleId: row.couple_id,
    title: row.title,
    targetLoss: typeof row.target_loss === "number" ? row.target_loss : Number(row.target_loss),
    achievedAt: row.achieved_at,
  };
}

export interface DietRewardInput {
  title: string;
  /** 二人合わせて減らす量。kg */
  targetLoss: number;
}

/**
 * 共同の約束なので、どちらでも決め直せる(couple に1行の upsert)。
 * couple_id は DB 側の既定値で埋まるので渡さない(→ profileItems.ts の upsert と同じ形)。
 */
export async function saveReward(input: DietRewardInput): Promise<void> {
  const { error } = await supabase.from("diet_rewards").upsert(
    {
      title: input.title,
      target_loss: input.targetLoss,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "couple_id" },
  );
  if (error) throw error;
}
